import React from "react";
import styles from "./experimental-banner.module.scss";

const ExperimentalBanner = () => {
  return (
    <div className={styles.banner} role="note">
      <span className={styles.icon} aria-hidden="true">⚠️</span>
      <span className={styles.text}>
        <strong>Experimental feature</strong> — under active development and may change at any time.
      </span>
    </div>
  );
};

export default ExperimentalBanner;
